// extracted by mini-css-extract-plugin
export default {"bullet":"List_bullet__zD5tK","clickable":"List_clickable__bV7Gq","dark":"List_dark__31Rs4"};